<template>
    <div>
        <component
            :is="component"
            v-for="(product, index) in offers"
            :key="product.info.name"
            :product="product"
            :data-cy="`extra-service-offer-${index}`"
            class="my-2"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import ExtraServiceCard from '@/components/extraServices/search/offers/ExtraServiceCard.vue'
    import ExtraServiceCardMobile from '@/components/extraServices/search/offers/ExtraServiceCardMobile.vue'

    @Component({
        components: {
            ExtraServiceCard,
            ExtraServiceCardMobile,
        },
    })
    export class ExtraServiceOffers extends Vue {
        @Prop({default: () => []}) offers

        get component() {
            return this.$breakpoint.smAndDown
                ? resolveComponent('ExtraServiceCardMobile')
                : resolveComponent('ExtraServiceCard')
        }
    }

    export default ExtraServiceOffers
</script>
